import ".././styles/GalleryPreview.css";
import picture from ".././assets/featuredevent4.jpg";
import useEmblaCarousel from "embla-carousel-react"
import React, { useEffect } from 'react'
import Autoplay from 'embla-carousel-autoplay'
import ".././styles/NewsAnnouncementsPreview.css";
import { HashLink as Link } from 'react-router-hash-link';
import MyModalImage from "./MyModalImage";
import gallerypic1 from ".././assets/gallerypic1.jpg";
import gallerypic2 from ".././assets/gallerypic2.jpg";
import gallerypic3 from ".././assets/gallerypic3.jpg";
import gallerypic4 from ".././assets/gallerypic4.jpg";
import gallerypic5 from ".././assets/gallerypic5.jpg";
function GalleryPreview() {

    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false },)
    useEffect(() => {
        if (emblaApi) {
            console.log(emblaApi.slideNodes()) // Access API
        }
    }, [emblaApi])

    return (
        <div className="gallery-preview-container container section">
            <div className="gallery-preview">
                <h2 className="section-title">
                    Gallery
                </h2>
                <div className="gallery-section">
                    <div className="gallery-images">
                        <MyModalImage item={gallerypic1}/>
                        <MyModalImage item={gallerypic2}/>
                        <MyModalImage item={gallerypic3}/>
                        <MyModalImage item={gallerypic4}/>
                        <MyModalImage item={gallerypic5}/>
                        <Link to="/gallery#images" className="view-more-gallery">
                            View More
                        </Link>
                    </div>

                </div>
                <div className="gallery-carousel">
                    <div className="embla-gallery" ref={emblaRef}>
                        <div className="embla-gallery-container">
                            <div className="embla-gallery-slide first-item">
                                <img src={gallerypic1} alt="" className="gallery-picture"></img>
                            </div>
                            <div className="embla-gallery-slide">
                                <img src={gallerypic2} alt="" className="gallery-picture"></img>
                            </div>
                            <div className="embla-gallery-slide">
                                <img src={gallerypic3} alt="" className="gallery-picture"></img>
                            </div>
                            <div className="embla-gallery-slide">
                                <img src={gallerypic4} alt="" className="gallery-picture"></img>
                            </div>
                            <div className="embla-gallery-slide">
                                <img src={gallerypic5} alt="" className="gallery-picture"></img>
                            </div>
                            <div className="embla-gallery-slide">
                                <Link to="/gallery#images"className="view-more-gallery">
                                    View More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GalleryPreview;